(function () {
  'use strict';

  var MAKE    = '#easysearch_field_34094';
  var MODEL   = '#easysearch_field_34092';
  var YEAR    = '#easysearch_field_34093';
  var HEADING = '#shopify-section-template--21499227472046__section h1';
  var SEARCH  = '#easysearch-search';

  var LS_MAKE       = 'es_make';
  var LS_MODEL      = 'es_model';
  var LS_YEAR       = 'es_year';
  var LS_MAKE_TEXT  = 'es_make_text';
  var LS_MODEL_TEXT = 'es_model_text';
  var LS_YEAR_TEXT  = 'es_year_text';
  var LS_PATH       = 'es_applied_path';
  var LS_APPLIED    = 'es_applied';
  var LS_APPLIED_MAKE  = 'es_applied_make';
  var LS_APPLIED_MODEL = 'es_applied_model';
  var LS_APPLIED_YEAR  = 'es_applied_year';
  var SS_PENDING    = 'es_pending_apply';

  var isResetting = false;
  var listenersBound = false;

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function normalizePath(path) {
    var p = path || window.location.pathname;
    return p.replace(/\/+$/, '') || '/';
  }

  function isCollectionPage(path) {
    return path.indexOf('/collections/') !== -1;
  }

  function isSearchPage(path) {
    return path.indexOf('/search') === 0;
  }

  function isFilterablePage(path) {
    return isCollectionPage(path) || isSearchPage(path);
  }

  function isGenericHeading(text) {
    if (!text) return false;
    var lower = text.trim().toLowerCase();
    return lower === 'all' || lower === 'all products' || lower === 'shop' || lower === 'products';
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function isExcludedHeading(el) {
    if (!el) return true;
    if (el.classList.contains('product-title') || el.classList.contains('ps-product__title')) {
      return true;
    }
    if (el.closest('.ps-product, .product-single, .product-template, .product-detail, [data-product-id]')) {
      return true;
    }
    if (el.closest('.ps-product--detail, .product__info, .product-info')) {
      return true;
    }
    return false;
  }

  function getHeadingEl() {
    if (isProductPage()) return null;

    var selectors = [
      HEADING,
      '.ps-hero .ps-hero__heading',
      '.ps-hero__heading',
      '.hero__container h1',
      '.hero h1',
      '.collection-hero__title',
      '.ps-breadcrumb .ps-hero__heading',
      '.ps-breadcrumb h1'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && !isExcludedHeading(el)) {
        return el;
      }
    }

    return null;
  }

  function getFieldEl(selector) {
    return document.querySelector(selector);
  }

  function getFieldValue(selector) {
    var el = getFieldEl(selector);
    if (!el) return '';

    if (el.value !== undefined && el.value !== null && el.value !== '') {
      return el.value;
    }

    var checked = el.querySelector('option:checked');
    return checked ? checked.value : '';
  }

  function isFilterField(el) {
    if (!el || !el.id) return false;
    return (
      el.id === 'easysearch_field_34094' ||
      el.id === 'easysearch_field_34092' ||
      el.id === 'easysearch_field_34093'
    );
  }

  function isResetButton(btn) {
    return btn && btn.textContent.trim().toLowerCase() === 'reset';
  }

  function getOptionText(selector) {
    var el = document.querySelector(selector + ' option:checked');
    if (el) return el.textContent.trim();

    var field = getFieldEl(selector);
    if (field && field.selectedIndex >= 0 && field.options[field.selectedIndex]) {
      return field.options[field.selectedIndex].textContent.trim();
    }

    return '';
  }

  function autoSelectYear() {
  var yearEl = getFieldEl(YEAR);
  if (!yearEl) return;

  // Only auto-select when Year has exactly one real option
  var yearOptions = Array.from(yearEl.options).filter(function (option) {
    return option.value && !option.hidden;
  });

  if (yearOptions.length === 1 && yearEl.value === '') {
    yearEl.value = yearOptions[0].value;

    // Let EasySearch know Year changed
    yearEl.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

  function isPlaceholder(text, label) {
    return !text || text === 'Select ' + label;
  }

  function buildFilterHeadingFromDOM() {
    var make  = getOptionText(MAKE);
    var model = getOptionText(MODEL);
    var year  = getOptionText(YEAR);
    var parts = [];

    if (!isPlaceholder(make, 'Make'))   parts.push(make);
    if (!isPlaceholder(model, 'Model')) parts.push(model);
    if (!isPlaceholder(year, 'Year'))   parts.push(year);

    return parts.join(' ');
  }

  function buildFilterHeadingFromStorage() {
    var parts = [];
    var make  = localStorage.getItem(LS_MAKE_TEXT);
    var model = localStorage.getItem(LS_MODEL_TEXT);
    var year  = localStorage.getItem(LS_YEAR_TEXT);

    if (make  && !isPlaceholder(make, 'Make'))   parts.push(make);
    if (model && !isPlaceholder(model, 'Model')) parts.push(model);
    if (year  && !isPlaceholder(year, 'Year'))   parts.push(year);

    return parts.join(' ');
  }

  function buildFilterHeading() {
    return buildFilterHeadingFromDOM() || buildFilterHeadingFromStorage();
  }

  function hasStoredFilters() {
    var make = localStorage.getItem(LS_MAKE);
    return !!(make && make !== '');
  }

  function hasAppliedFilters() {
    return localStorage.getItem(LS_APPLIED) === '1';
  }

  function filtersDirty() {
    if (!hasAppliedFilters()) return false;

    var make  = getFieldValue(MAKE)  || '';
    var model = getFieldValue(MODEL) || '';
    var year  = getFieldValue(YEAR)  || '';

    return make  !== (localStorage.getItem(LS_APPLIED_MAKE)  || '') ||
           model !== (localStorage.getItem(LS_APPLIED_MODEL) || '') ||
           year  !== (localStorage.getItem(LS_APPLIED_YEAR)  || '');
  }

  function unapplyFilters() {
    localStorage.removeItem(LS_APPLIED);
    localStorage.removeItem(LS_PATH);
    localStorage.removeItem(LS_APPLIED_MAKE);
    localStorage.removeItem(LS_APPLIED_MODEL);
    localStorage.removeItem(LS_APPLIED_YEAR);
  }

  function pathsMatch(a, b) {
    return normalizePath(a) === normalizePath(b);
  }

  function captureOriginalHeading() {
    var heading = getHeadingEl();
    if (heading && !heading.dataset.originalHeading) {
      heading.dataset.originalHeading = heading.textContent.trim();
    }
  }

  function restoreOriginalHeading() {
    var heading = getHeadingEl();
    if (heading && heading.dataset.originalHeading) {
      heading.textContent = heading.dataset.originalHeading;
    }
  }

  function migrateLegacyAppliedPath(currentPath) {
    if (localStorage.getItem(LS_PATH) || !hasStoredFilters()) return;

    var heading = getHeadingEl();
    var original = (heading && heading.dataset.originalHeading) ||
      (heading && heading.textContent.trim()) || '';

    if (isGenericHeading(original)) {
      localStorage.setItem(LS_PATH, normalizePath(currentPath));
      localStorage.setItem(LS_APPLIED, '1');
    }
  }

  // ---------------------------------------------------------------------------
  // EasySearch + localStorage
  // ---------------------------------------------------------------------------

  function clearEasysearchPluginState() {
    try {
      if (typeof easysearch !== 'undefined') {
        if (typeof easysearch.clearSearchParams === 'function') easysearch.clearSearchParams();
        if (typeof easysearch.resetSearch === 'function') easysearch.resetSearch();
        if (typeof easysearch.clearFilters === 'function') easysearch.clearFilters();
        if (typeof easysearch.reset === 'function') easysearch.reset();
      }
    } catch (err) {}

    var keysToRemove = [];
    var i;
    for (i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key && (
        key.indexOf('easysearch') === 0 ||
        key.indexOf('EasySearch') === 0 ||
        key.indexOf('es_') === 0
      )) {
        if (key !== LS_MAKE && key !== LS_MODEL && key !== LS_YEAR &&
            key !== LS_MAKE_TEXT && key !== LS_MODEL_TEXT && key !== LS_YEAR_TEXT &&
            key !== LS_PATH && key !== LS_APPLIED) {
          keysToRemove.push(key);
        }
      }
    }
    for (i = 0; i < keysToRemove.length; i++) {
      localStorage.removeItem(keysToRemove[i]);
    }
  }

  function saveFilters() {
    var makeVal  = getFieldValue(MAKE);
    var modelVal = getFieldValue(MODEL);
    var yearVal  = getFieldValue(YEAR);

    if (makeVal)  localStorage.setItem(LS_MAKE, makeVal);
    else          localStorage.removeItem(LS_MAKE);

    if (modelVal) localStorage.setItem(LS_MODEL, modelVal);
    else          localStorage.removeItem(LS_MODEL);

    if (yearVal)  localStorage.setItem(LS_YEAR, yearVal);
    else          localStorage.removeItem(LS_YEAR);

    var makeText  = getOptionText(MAKE);
    var modelText = getOptionText(MODEL);
    var yearText  = getOptionText(YEAR);

    if (!isPlaceholder(makeText, 'Make')) {
      localStorage.setItem(LS_MAKE_TEXT, makeText);
    } else {
      localStorage.removeItem(LS_MAKE_TEXT);
    }

    if (!isPlaceholder(modelText, 'Model')) {
      localStorage.setItem(LS_MODEL_TEXT, modelText);
    } else {
      localStorage.removeItem(LS_MODEL_TEXT);
    }

    if (!isPlaceholder(yearText, 'Year')) {
      localStorage.setItem(LS_YEAR_TEXT, yearText);
    } else {
      localStorage.removeItem(LS_YEAR_TEXT);
    }
  }

  function clearFilters() {
    localStorage.removeItem(LS_MAKE);
    localStorage.removeItem(LS_MODEL);
    localStorage.removeItem(LS_YEAR);
    localStorage.removeItem(LS_MAKE_TEXT);
    localStorage.removeItem(LS_MODEL_TEXT);
    localStorage.removeItem(LS_YEAR_TEXT);
    localStorage.removeItem(LS_PATH);
    localStorage.removeItem(LS_APPLIED);
    localStorage.removeItem(LS_APPLIED_MAKE);
    localStorage.removeItem(LS_APPLIED_MODEL);
    localStorage.removeItem(LS_APPLIED_YEAR);
    sessionStorage.removeItem(SS_PENDING);
    clearEasysearchPluginState();
  }

  function markFiltersApplied() {
    saveFilters();
    localStorage.setItem(LS_APPLIED_MAKE,  getFieldValue(MAKE)  || '');
    localStorage.setItem(LS_APPLIED_MODEL, getFieldValue(MODEL) || '');
    localStorage.setItem(LS_APPLIED_YEAR,  getFieldValue(YEAR)  || '');
    localStorage.setItem(LS_PATH, normalizePath(window.location.pathname));
    localStorage.setItem(LS_APPLIED, '1');
  }

  function persistApply() {
    var makeVal = getFieldValue(MAKE);
    if (!makeVal) return false;

    saveFilters();
    sessionStorage.setItem(SS_PENDING, '1');

    setTimeout(function () {
      if (sessionStorage.getItem(SS_PENDING) !== '1') return;
      markFiltersApplied();
      sessionStorage.removeItem(SS_PENDING);
      applyHeadingLogic();
      updateButton();
    }, 400);

    return true;
  }

  function commitPendingApply() {
    if (sessionStorage.getItem(SS_PENDING) === '1' && hasStoredFilters()) {
      localStorage.setItem(LS_APPLIED_MAKE,  localStorage.getItem(LS_MAKE)  || '');
      localStorage.setItem(LS_APPLIED_MODEL, localStorage.getItem(LS_MODEL) || '');
      localStorage.setItem(LS_APPLIED_YEAR,  localStorage.getItem(LS_YEAR)  || '');
      localStorage.setItem(LS_PATH, normalizePath(window.location.pathname));
      localStorage.setItem(LS_APPLIED, '1');
      sessionStorage.removeItem(SS_PENDING);
      return true;
    }
    return false;
  }

  // ---------------------------------------------------------------------------
  // Heading
  // ---------------------------------------------------------------------------

  function updateHeadingPreview() {
    if (isProductPage()) return;

    var heading = getHeadingEl();
    if (!heading) return;

    captureOriginalHeading();

    var filterHeading = buildFilterHeading();

    if (filterHeading && hasStoredFilters()) {
      heading.textContent = filterHeading;
    } else {
      restoreOriginalHeading();
    }
  }

  function pollHeadingPreview(attempts) {
    if (isProductPage()) return;

    var max = attempts || 12;
    var count = 0;

    var timer = setInterval(function () {
      count++;
      updateHeadingPreview();
      if (count >= max) {
        clearInterval(timer);
      }
    }, 250);
  }

  function applyHeadingLogic() {
    if (isProductPage()) return false;

    var heading = getHeadingEl();
    if (!heading) return false;

    captureOriginalHeading();

    var currentPath = normalizePath(window.location.pathname);
    var appliedPath = localStorage.getItem(LS_PATH);
    var filterActive = hasAppliedFilters() && hasStoredFilters();

    migrateLegacyAppliedPath(currentPath);
    appliedPath = localStorage.getItem(LS_PATH);

    if (!filterActive) {
      restoreOriginalHeading();
      return false;
    }

    var filterHeading = buildFilterHeading();

    if (appliedPath && pathsMatch(currentPath, appliedPath)) {
      if (filterHeading) {
        heading.textContent = filterHeading;
        return true;
      }
      return false;
    }

    if (isFilterablePage(currentPath)) {
      if (filterHeading) {
        heading.textContent = filterHeading;
        return true;
      }
      restoreOriginalHeading();
      return false;
    }

    if (filterHeading) {
      heading.textContent = filterHeading;
      return true;
    }

    return false;
  }

  function pollHeading(attempts) {
    if (isProductPage()) return;

    var max = attempts || 40;
    var count = 0;

    var timer = setInterval(function () {
      count++;
      if (applyHeadingLogic() || count >= max) {
        clearInterval(timer);
      }
    }, 250);
  }

  // ---------------------------------------------------------------------------
  // Dropdown restore / reset
  // ---------------------------------------------------------------------------

  function resetDropdownsToDefault() {
    isResetting = true;

    var makeEl  = getFieldEl(MAKE);
    var modelEl = getFieldEl(MODEL);
    var yearEl  = getFieldEl(YEAR);

    if (makeEl)  makeEl.selectedIndex = 0;
    if (modelEl) modelEl.selectedIndex = 0;
    if (yearEl)  yearEl.selectedIndex = 0;

    if (makeEl)  makeEl.dispatchEvent(new Event('change', { bubbles: true }));
    if (modelEl) modelEl.dispatchEvent(new Event('change', { bubbles: true }));
    if (yearEl)  yearEl.dispatchEvent(new Event('change', { bubbles: true }));

    setTimeout(function () {
      isResetting = false;
    }, 600);
  }

  function pollAndSet(selector, value, callback) {
    if (!value) {
      if (callback) callback();
      return;
    }

    var attempts = 0;

    var timer = setInterval(function () {
      attempts++;
      var el = document.querySelector(selector);

      if (el && el.options.length > 1) {
        var match = null;
        var j;
        for (j = 0; j < el.options.length; j++) {
          if (el.options[j].value == value || el.options[j].textContent.trim() === value) {
            match = el.options[j];
            break;
          }
        }

        if (match) {
          el.value = match.value;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          clearInterval(timer);
          if (callback) callback();
          return;
        }
      }

      if (attempts > 200) {
        clearInterval(timer);
        if (callback) callback();
      }
    }, 300);
  }

  function restoreFilters(callback) {
    if (!hasAppliedFilters() || !hasStoredFilters()) {
      if (!hasAppliedFilters()) {
        resetDropdownsToDefault();
      }
      if (callback) callback();
      return;
    }

    var makeVal  = localStorage.getItem(LS_MAKE);
    var modelVal = localStorage.getItem(LS_MODEL);
    var yearVal  = localStorage.getItem(LS_YEAR);

    pollAndSet(MAKE, makeVal, function () {
      pollAndSet(MODEL, modelVal, function () {
        setTimeout(function () {
          pollAndSet(YEAR, yearVal, function () {
            saveFilters();
            if (callback) callback();
          });
        }, 200);
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Search / Reset button
  // ---------------------------------------------------------------------------

  function updateButton() {
    var btn = document.querySelector(SEARCH);
    if (!btn) return;

    if (!btn.dataset.originalHref && btn.getAttribute('href')) {
      btn.dataset.originalHref = btn.getAttribute('href');
    }

    btn.removeAttribute('onclick');

    if (hasAppliedFilters()) {
      btn.textContent = 'Reset';
      btn.href = '#';
      btn.className = 'easysearch-btn easysearch-btn-search ymm-reset-btn';

      btn.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        clearFilters();
        resetDropdownsToDefault();
        restoreOriginalHeading();

        btn.textContent = 'Search';
        btn.className = 'easysearch-btn easysearch-btn-search';
        btn.onclick = null;

        if (btn.dataset.originalHref) {
          btn.setAttribute('href', btn.dataset.originalHref);
        }
      };
    } else {
      btn.textContent = 'Search';
      btn.className = 'easysearch-btn easysearch-btn-search';
      btn.onclick = null;

      if (btn.dataset.originalHref) {
        btn.setAttribute('href', btn.dataset.originalHref);
      }
    }
  }

  function onSearchApply(e) {
    var btn = e.target.closest ? e.target.closest('#easysearch-search') : null;
    if (!btn || isResetButton(btn)) return;
    persistApply();
  }

  function onFilterChange(e) {
  if (isResetting) return;
  if (!isFilterField(e.target)) return;

  // Auto-select Year when Make/Model leaves only one Year available
  if (e.target.id === 'easysearch_field_34094' ||
      e.target.id === 'easysearch_field_34092') {
    setTimeout(function () {
      autoSelectYear();
    }, 100);
  }

  saveFilters();

  // Applied filters changed without Reset — require Search again
  if (hasAppliedFilters() && filtersDirty()) {
    unapplyFilters();
  }

  updateHeadingPreview();
  updateButton();
  pollHeadingPreview(12);
}

  function bindGlobalListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('change', onFilterChange, true);
    document.addEventListener('input', onFilterChange, true);
    document.addEventListener('mousedown', onSearchApply, true);
    document.addEventListener('click', onSearchApply, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest('.easysearch-block-container, .easysearch-container')) return;
      persistApply();
    }, true);
  }

  function watchForEasySearch() {
    var restored = false;
    var cleared = false;
    var attempts = 0;

    var timer = setInterval(function () {
      attempts++;
      var makeEl = getFieldEl(MAKE);
      var searchBtn = document.querySelector(SEARCH);

      if (makeEl || searchBtn) {
        bindGlobalListeners();
        updateButton();

        if (hasAppliedFilters() && !restored) {
          restored = true;
          restoreFilters(afterRestore);
        } else if (!hasAppliedFilters() && makeEl && !cleared) {
          cleared = true;
          resetDropdownsToDefault();
        }
      }

      if ((makeEl && searchBtn) || attempts > 100) {
        clearInterval(timer);
      }
    }, 300);
  }

  // ---------------------------------------------------------------------------
  // Mobile widget
  // ---------------------------------------------------------------------------

  function initMobileWidget() {
    // Only Home Page
  if (window.location.pathname !== '/') {
    return;
  }
    if (window.innerWidth > 768) return;

    var style = document.createElement('style');
    style.textContent = '@media screen and (max-width: 768px) { .easysearch-block-container { display: none !important; } }';
    document.head.appendChild(style);

    document.addEventListener('DOMContentLoaded', function () {
      var widget = document.querySelector('.easysearch-block-container');
      if (!widget) return;

      var heroContainer = document.querySelector('.hero__container');
      if (!heroContainer) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'ymm-mobile-wrapper';
      wrapper.style.cssText = 'width:100%; clear:both;';

      var btn = document.createElement('div');
      btn.className = 'ymm-toggle-button mobile-only';
      btn.id = 'ymmToggleBtn';
      btn.innerHTML = [
        '<svg class="chevron-icon" viewBox="0 0 20 20" width="16" height="16">',
        '  <path d="M5 8l5 5 5-5" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"/>',
        '</svg>',
        '<span>Click - Find Parts For Your Vehicle</span>',
        '<svg class="chevron-icon" viewBox="0 0 20 20" width="16" height="16">',
        '  <path d="M5 8l5 5 5-5" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"/>',
        '</svg>'
      ].join('');

      wrapper.appendChild(btn);
      wrapper.appendChild(widget);
      heroContainer.parentNode.insertBefore(wrapper, heroContainer.nextSibling);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = wrapper.classList.toggle('ymm-open');
        btn.classList.toggle('active', isOpen);
      });

      var styleFinal = document.createElement('style');
      styleFinal.textContent = [
        '@media screen and (max-width: 768px) {',
        '  .ymm-mobile-wrapper { display: block; width: 100%; clear: both; margin: 0; padding: 0; }',
        '  .ymm-mobile-wrapper .easysearch-block-container { display: none !important; }',
        '  .ymm-mobile-wrapper.ymm-open .easysearch-block-container { display: block !important; }',
        '  .ymm-toggle-button.mobile-only {',
        '    display: flex !important; align-items: center; justify-content: space-between;',
        '    cursor: pointer; padding: 12px 16px; background: black !important;',
        '    font-weight: 600; font-size: 16px; color: white !important;',
        '    transition: background 0.2s; margin: 0; border: none; width: 100%;',
        '    box-sizing: border-box; position: relative; top: -20px;',
        '  }',
        '  .ymm-toggle-button.mobile-only:hover { background: black !important; color: white !important; }',
        '  .ymm-toggle-button.mobile-only .chevron-icon path { stroke: white !important; }',
        '  .ymm-toggle-button.mobile-only .chevron-icon { transition: transform 0.3s; }',
        '  .ymm-toggle-button.mobile-only.active .chevron-icon { transform: rotate(180deg); }',
        '  .ymm-mobile-wrapper .easysearch-header-holder { display: none !important; }',
        '  .hero { min-height: 140px !important; }',
        '  .easysearch-container.easysearch-vertical-mode { margin-top: -20px; }',
        '  .ymm-reset-btn { background: #dc3545 !important; color: white !important; }',
        '  .ymm-reset-btn:hover { background: #c82333 !important; color: white !important; }',
        '}'
      ].join('\n');
      document.head.appendChild(styleFinal);

      if (hasAppliedFilters()) {
        setTimeout(function () {
          wrapper.classList.add('ymm-open');
          btn.classList.add('active');
        }, 1000);
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Init + navigation
  // ---------------------------------------------------------------------------

  function afterRestore() {
    commitPendingApply();
    applyHeadingLogic();
    updateButton();
    pollHeading(40);
  }

  function refreshUI() {
    captureOriginalHeading();
    commitPendingApply();

    if (hasAppliedFilters()) {
      restoreFilters(afterRestore);
    } else {
      resetDropdownsToDefault();
      restoreOriginalHeading();
      updateButton();
    }
  }

  function init() {
    bindGlobalListeners();
    watchForEasySearch();
    refreshUI();
    pollHeading(20);
  }

  initMobileWidget();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function () {
    refreshUI();
  });

  var oldPushState = history.pushState;
  history.pushState = function () {
    oldPushState.apply(history, arguments);
    setTimeout(refreshUI, 300);
  };

  window.addEventListener('popstate', function () {
    setTimeout(refreshUI, 300);
  });

})();
